import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    console.log('🔄 [PWA] Attempting to register service worker...');
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('🚀 [PWA] Service Worker registered successfully:', registration.scope);
        console.log('📋 [PWA] Registration details:', registration);
        
        // Check if it's active
        if (registration.active) {
          console.log('✅ [PWA] Service Worker is active');
        } else {
          console.log('⏳ [PWA] Service Worker is installing/waiting');
        }
      })
      .catch((error) => {
        console.error('❌ [PWA] Service Worker registration failed:', error);
      });
  });
} else {
  console.warn('⚠️ [PWA] Service Worker not supported in this browser');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)